import React, { useMemo, useContext } from 'react';

import { PlaylistWrapperMobile } from 'components/Playlist/PlaylistUI';
import { MobileVideoPlayer } from 'components/VideoPlayer';
import { GetDocumentCover, sortDocuments } from 'utils/NwUtils';
import { ConfigContext } from 'contexts/ConfigContext';

const PlaylistMobile = ({
    playlist,
    playlistIndex,
}) => {

    const sortedDocuments = useMemo(() => {
        let documentPlaylists = []
        if (playlist) {
            documentPlaylists = sortDocuments(playlist.DocumentPlaylists);
        }
        return documentPlaylists;
    }, [playlist])

    const { clientConfig } = useContext(ConfigContext);
    const { playlistViewer } = clientConfig;
    const { showPublicDescription } = playlistViewer;

    const PlaylistItem = ({ document }) => {
        if (document.Type === "Video") {
            return (
                <div className="playlist-video-wrapper">
                    <MobileVideoPlayer
                        document={document}
                    />
                </div>
            )
        } else {
            return (
                <div className="playlist-image-wrapper">
                    <img src={GetDocumentCover(document)} alt="" />
                    {showPublicDescription && document.PublicDescription && (
                        <div className="public-description">{document.PublicDescription}</div>
                    )}
                </div>
            )
        }
    }

    return (
        ((sortedDocuments && sortedDocuments.length > 0)
            ?
            <PlaylistWrapperMobile>
                <div className="playlist-mobile-documents">
                    {sortedDocuments.map((document, index) => (
                        <PlaylistItem key={index} document={document} />
                    ))}
                </div>
            </PlaylistWrapperMobile>
            :
            <div></div>
        )
    )

};

export default PlaylistMobile;
